import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ReactApexChart from "react-apexcharts";

import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import  "./../assets/css/custom.css"; 
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ApexCharts from "apexcharts";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const MainDashboard = () => {
  const [menu, setMenu] = useState(false);
  const [cusomerbalance, setCusomerbalance] = useState([]);
  const [cusomerrevenues, setCusomerrevenues] = useState([]);
  const [dataacaliber, setDataacaliber] = useState([]);
  const [customerpayment, setCustomerpayment] = useState([]);
  const [customernetweight, setCustomernetweight] = useState([]);
  
  const [groupbycustomer, setGroupbycustomer] = useState([]);
  const [dateprices, setDateprices] = useState([]);


  
// const [showPicker, setShowPicker] = useState(false);
  const [dataBoxes, setDataBoxes] = useState([]);
  const [customertotalreceivedopen, setCustomertotalreceivedopen] = useState({});
   let season_id = localStorage.getItem("season_id");

     let season_start = localStorage.getItem("season_start");
   let season_end = localStorage.getItem("season_end");
let season_name = localStorage.getItem("season_name");

  
   season_start = new Date(season_start);
   season_end = new Date(season_end);


function getStartOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay(); // Sunday = 0
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
  return new Date(d.setDate(diff));
}

function getStartOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

function getEndOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function getStartOfYear(date) {
  return new Date(date.getFullYear(), 0, 1);
}
function getEndOfYear(date) {
  return new Date(date.getFullYear(), 11, 31);
}

  const now = new Date();

  const lastYearStart = new Date(now.getFullYear() - 1, 0, 1);
  const lastYearEnd = new Date(now.getFullYear() - 1, 11, 31);


  const predefinedRanges = [
    {
      label: 'This Week',
      value: [getStartOfWeek(now), now],
      closeOverlay: true,
      status: 0
    },
    {
      label: 'This Month',
      value: [getStartOfMonth(now), getEndOfMonth(now)],
      closeOverlay: true,
      status: 0
    },
    {
      label: 'This Year',
      value: [getStartOfYear(now), getEndOfYear(now)],
      closeOverlay: true,
      status: 0
    },
    {
      label: 'Last Year',
      value: [lastYearStart, lastYearEnd],
      closeOverlay: true,
      status: 0
    },
   
    {
      label: season_name,
      value: [season_start, season_end],
      closeOverlay: true,
      status: 1
    },
 
  ];
      
    
        const defaultRange = predefinedRanges.find(range => range.status == 1)?.value || predefinedRanges[0].value;


      const [value, setValue] = useState(defaultRange); // index 2 is "This Year"
      
      const toggleMobileMenu = () => {
        setMenu(!menu);
      };
    useEffect(() => {
      fetchDashboardData(value);


    }, []);

  const fetchDashboardData = (range) => {
  
      const startDate = toLocalDateString(range[0]);
      const endDate = toLocalDateString(range[1]);

      const formattedRange = {
        season_id,
      startDate,
      endDate
      };



        axios.post("/dashboard/top-boxes",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              if (response.data.code === 200) {
                setDataBoxes(response.data.data);
              }else{
                setTimeout(() => {
                  window.location.href = "/login";
                }, 500);
              }
            }).catch((error) => {
              console.log(error);
            });

            
      axios.post("/dashboard/customer-netweight",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
          if (response.data.code === 200) {
            let dataa =response.data.data.customers;
            const customerNames = dataa.map(item => item.company_name);
              const netWeights = dataa.map(item => item.total_net_weight);
              const colors = dataa.map(item => item.color);
             // const colors = customerNames.map(() => getRandomColor());

              const chartData = {
                labels: customerNames,
                series: netWeights,
                colors: colors
              };
              setCustomernetweight(chartData)

             //console.log(customernetweight);
              }
        })  .catch((error) => {
          console.log(error);
        });

      
        axios.post("/dashboard/customers-revenues",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
            if (response.data.code === 200) {
              // let call_customer =  response.data.data.customers;
              // const receivedAmount = call_customer.reduce((sum, c) => sum + Number(c.paid_amount), 0);
              // const totalOpenAmount = call_customer.reduce((sum, c) => sum + Number(c.open_amount), 0);

              // const customerDatatotal = {
              //     received: receivedAmount,
              //     open: totalOpenAmount
              //   };

              // setCustomertotalreceivedopen(customerDatatotal)
       

              //   const customerData = {
              //     customer_names: call_customer.map(c => c.company_name),
              //     sum_paid_all: call_customer.map(c => c.paid_amount),
              //     open_amount_all: call_customer.map(c => c.open_amount)
              //   };
              //   setCusomerrevenues(customerData)
              let call_customer = response.data.data.customers;

              // sort by open_amount (largest → smallest)
              call_customer.sort((a, b) => Number(b.open_amount) - Number(a.open_amount));

              const receivedAmount = call_customer.reduce((sum, c) => sum + Number(c.paid_amount), 0);
              const totalOpenAmount = call_customer.reduce((sum, c) => sum + Number(c.open_amount), 0);

              const customerDatatotal = {
                received: receivedAmount,
                open: totalOpenAmount
              };
              setCustomertotalreceivedopen(customerDatatotal);

              const customerData = {
                customer_names: call_customer.map(c => c.company_name),
                sum_paid_all: call_customer.map(c => Number(c.paid_amount)),
                open_amount_all: call_customer.map(c => Number(c.open_amount))
              };
              setCusomerrevenues(customerData);
           }
          })  .catch((error) => {
            console.log(error);
          });
            axios.post("/dashboard/customers-balances",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
            if (response.data.code === 200) {
              setCusomerbalance(response.data.data.customers);
              
           }
          })  .catch((error) => {
            console.log(error);
          });

            axios.post("/dashboard/daily-production-reports/listing-groupby-caliber",formattedRange,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },} )
              .then((response) => {
               
                var all_calibers = response.data.data.reports_groupby_calibres;
                  const totalQuantity2 = all_calibers.reduce((sum, item) => sum + Number(item.quantity), 0);
                   const updatedData = all_calibers.map(item => {
                              const quantity = parseInt(item.quantity, 10) || 0;
                          
                              const percentage = (quantity / totalQuantity2) * 100;

                              return {
                                ...item,
                                percentage
                              };
                            });
                     
                            //console.log(updatedData);
                        const sortedData = [...updatedData].sort((a, b) => Number(a.calibre) - Number(b.calibre));

                        const customerData = {
                        all_calibre: sortedData.map(c => c.calibre),
                        all_percentage: sortedData.map(c =>Number(c.percentage.toFixed(4)))
                      };
                     
                        setDataacaliber(customerData);
              
                    })  .catch((error) => {
                      console.log(error);
                    });

       axios.post(
        "/dashboard/trader-farmer-supplier-cost-new",
       formattedRange,
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        let all_supplier =response.data.data.suppliers;
        //console.log(all_supplier);
        const topSuppliers = all_supplier
          .map(supplier => ({
            ...supplier,
            situation: parseFloat(supplier.situation.replace(/,/g, ''))
          }))
          .sort((a, b) => b.situation - a.situation)
          .slice(0, 10);
        
        setCustomerpayment(topSuppliers);
      })
      .catch((error) => {
        console.log(error);
      });

          axios
          .post("/dashboard/decay-sales-customer", formattedRange, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          }) .then((response) => {
            if (response.data.code === 200) {
              let all_customers =response.data.data.groupby_customer;
           
                  const customersWithOpenAmount = all_customers.map(item => {
                        const open_amount = (item.customer_total_price || 0) - (item.customer_paid_amount?.total_cost || 0);
                        return {
                          ...item,
                          open_amount
                        };
                      });

                      // Sort descending by open_amount
                  const top10Customers = customersWithOpenAmount
                    .sort((a, b) => b.open_amount - a.open_amount)
                    .slice(0, 10);

                  setGroupbycustomer(top10Customers);
            } 
            else {
               //setBackendErrors(response.data.error);
            }
          })
          .catch((error) => {
            console.log(error)
           // actions.setSubmitting(false);
          });


     
        axios.post("/dashboard/datelocation",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
         
          if (response.data.code === 200) {
            let dataa =response.data.data.dates;
                 const customersWithOpenAmount = dataa.map(item => {
                    const total = item.total_net_weight_price || 0;
                    const weight = item.sum_net_weight || 0;
                    const average_price = weight > 0 ? Number((total / weight).toFixed(2)) : 0;
                    return {
                      ...item,
                      average_price
                    };
                  });
                   console.log(dataa);
                   const all_dates = customersWithOpenAmount.map(item => item.week_start_date + ' to ' + item.week_end_date);

              const allprices = customersWithOpenAmount.map(item => item.average_price);

              const chartData21 = {
                dates: all_dates,
                prices: allprices,
              };
              setDateprices(chartData21)
            
        
              }
        })
        .catch((error) => {
          console.log(error);
        });

  }


 const toLocalDateString = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
const handleDateChange2 = (item) => {
  if (!item || !Array.isArray(item) || item.length < 2) {
    console.warn("Invalid date range selected:", item);
    return;
  }

  setValue(item);

  const startDate = toLocalDateString(item[0]);
  const endDate = toLocalDateString(item[1]);

  const formattedRange = {
    startDate,
    endDate,
    season_id
  };

  
        axios.post("/dashboard/top-boxes",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              if (response.data.code === 200) {
                setDataBoxes(response.data.data);
              }else{
                setTimeout(() => {
                  window.location.href = "/login";
                }, 500);
              }
            }).catch((error) => {
              console.log(error);
            });

                        
      axios.post("/dashboard/customer-netweight",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
          if (response.data.code === 200) {
            let dataa =response.data.data.customers;
            const customerNames = dataa.map(item => item.company_name);
              const netWeights = dataa.map(item => item.total_net_weight);
              const colors = dataa.map(item => item.color);
             // const colors = customerNames.map(() => getRandomColor());

              const chartData = {
                labels: customerNames,
                series: netWeights,
                colors: colors
              };
              setCustomernetweight(chartData)

             //console.log(customernetweight);
              }
        })  .catch((error) => {
          console.log(error);
        });

      
           axios.post("/dashboard/customers-revenues",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
            if (response.data.code === 200) {
              let call_customer =  response.data.data.customers;
                const customerData = {
                  customer_names: call_customer.map(c => c.company_name),
                  sum_paid_all: call_customer.map(c => c.paid_amount),
                  open_amount_all: call_customer.map(c => c.open_amount)
                };
                setCusomerrevenues(customerData)
           }
          })  .catch((error) => {
            console.log(error);
          });
            axios.post("/dashboard/customers-balances",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
            if (response.data.code === 200) {
              setCusomerbalance(response.data.data.customers);
              
           }
          })  .catch((error) => {
            console.log(error);
          });

            axios.post("/dashboard/daily-production-reports/listing-groupby-caliber",formattedRange,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },} )
              .then((response) => {
               
                var all_calibers = response.data.data.reports_groupby_calibres;
                  const totalQuantity2 = all_calibers.reduce((sum, item) => sum + Number(item.quantity), 0);
                   const updatedData = all_calibers.map(item => {
                              const quantity = parseInt(item.quantity, 10) || 0;
                          
                              const percentage = (quantity / totalQuantity2) * 100;

                              return {
                                ...item,
                                percentage
                              };
                            });
                     
                      const sortedData = [...updatedData].sort((a, b) => Number(a.calibre) - Number(b.calibre));

                        const customerData = {
                        all_calibre: sortedData.map(c => c.calibre),
                        all_percentage: sortedData.map(c =>Number(c.percentage.toFixed(4)))
                      };
                     
                        setDataacaliber(customerData);
              
                    })  .catch((error) => {
                      console.log(error);
                    });

       axios.post(
        "/dashboard/trader-farmer-supplier-cost-new",
        formattedRange,
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        let all_supplier =response.data.data.suppliers;
        //console.log(all_supplier);
        const topSuppliers = all_supplier
          .map(supplier => ({
            ...supplier,
            situation: parseFloat(supplier.situation.replace(/,/g, ''))
          }))
          .sort((a, b) => b.situation - a.situation)
          .slice(0, 10);
        
        setCustomerpayment(topSuppliers);
      })
      .catch((error) => {
        console.log(error);
      });

          axios
          .post("/dashboard/decay-sales-customer", formattedRange, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          }) .then((response) => {
            if (response.data.code === 200) {
              let all_customers =response.data.data.groupby_customer;
           
                  const customersWithOpenAmount = all_customers.map(item => {
                        const open_amount = (item.customer_total_price || 0) - (item.customer_paid_amount?.total_cost || 0);
                        return {
                          ...item,
                          open_amount
                        };
                      });

                      // Sort descending by open_amount
                  const top10Customers = customersWithOpenAmount
                    .sort((a, b) => b.open_amount - a.open_amount)
                    .slice(0, 10);

                  setGroupbycustomer(top10Customers);
            } 
            else {
               //setBackendErrors(response.data.error);
            }
          })
          .catch((error) => {
            console.log(error)
           // actions.setSubmitting(false);
          });


     
        axios.post("/dashboard/datelocation",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
         
          if (response.data.code === 200) {
            let dataa =response.data.data.dates;
            console.log(dataa);
                 const customersWithOpenAmount = dataa.map(item => {
                    const total = item.total_net_weight_price || 0;
                    const weight = item.sum_net_weight || 0;
                    const average_price = weight > 0 ? Number((total / weight).toFixed(2)) : 0;
                    return {
                      ...item,
                      average_price
                    };
                  });
                 const all_dates = customersWithOpenAmount.map(item => item.week_start_date + ' to ' + item.week_end_date);

              const allprices = customersWithOpenAmount.map(item => item.average_price);

              const chartData21 = {
                dates: all_dates,
                prices: allprices,
              };
              setDateprices(chartData21)
            
        
              }
        })
        .catch((error) => {
          console.log(error);
        });
};
  
  // var sLineArea = {
  //   chart: {
  //     height: 350,
  //     type: "area",
  //     toolbar: {
  //       show: false,
  //     },
  //   },
  //   // colors: ['#4361ee', '#888ea8'],
    
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   stroke: {
  //     curve: "smooth",
  //   },
  //   series: [
      
  //     {
  //       name: "Average",
  //     data: dateprices?.prices || [],
  //     },
     
  //   ],

  //   xaxis: {
  //     type: "datetime",
    
  //      categories: dateprices?.dates || [],
 
  //      },
  //        yaxis: {
  //   labels: {
  //     formatter: function (value) {
  //       return value + " MAD";
  //     },
  //   },
  // },
  //   tooltip: {
  //     x: {
  //       format: "dd/MM/yy HH:mm",
  //     },
  //   },
  // };
//   var sLineArea = {
//   chart: {
//     height: 350,
//     type: "area",
//     toolbar: {
//       show: false,
//     },
//   },
//   dataLabels: {
//     enabled: false,
//   },
//   stroke: {
//     curve: "smooth",
//   },
//   series: [
//     {
//       name: "Average",
//       data: dateprices?.prices || [],
//     },
//   ],
//   xaxis: {
//     type: "category", // ✅ use category, not datetime
//     categories: dateprices?.dates || [],
//     labels: {
//       rotate: -45, // optional for better readability
//     },
//   },
//   yaxis: {
//     labels: {
//       formatter: function (value) {
//         return value + " MAD";
//       },
//     },
//   },
//   tooltip: {
//     x: {
//       show: true,
//       formatter: function (val) {
//         return val; // show "2025-10-20 to 2025-10-26" in tooltip
//       },
//     },
//   },
// };
var sLineArea = {
  chart: {
    height: 350,
    type: "area",
    toolbar: { show: false },
    zoom: { enabled: false },
  },
  dataLabels: { enabled: false },
  stroke: { curve: "smooth" },
  series: [
    {
      name: "Average",
      data: dateprices?.prices || [],
    },
  ],
  xaxis: {
    type: "category",
    categories: dateprices?.dates || [],
    tickPlacement: "on", // ✅ reduces horizontal gap between ticks
    labels: {
      rotate: -45,
      style: { fontSize: "12px" },
    },
  },
  grid: {
    padding: {
      left: 0,
      right: 0, // ✅ removes extra space on sides
    },
  },
  yaxis: {
    labels: {
      formatter: function (value) {
        return value + " MAD";
      },
    },
  },
  tooltip: {
    x: {
      show: true,
      formatter: function (val) {
        return val;
      },
    },
  },
};




   
  const invoiceOptions = {
  colors: customernetweight.colors || [],
  chart: {
    fontFamily: "Poppins, sans-serif",
    height: 350,
    type: "donut",
  },
  series: customernetweight.series || [],
  labels: customernetweight.labels || [],
  legend: {
    show: true,
    position: 'bottom'
  },
  dataLabels: {
    formatter: function (val, opts) {
      const value = opts.w.config.series[opts.seriesIndex];
      return `${value} KG`;
    }
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return `${val} KG`;
      }
    }
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 400,
        },
        legend: {
          position: "bottom",
        },
      },
    },
  ],
};

  
  useEffect(() => {
 

  }, []);

  useEffect(() => {
  if (customernetweight.series && customernetweight.series.length > 0) {
    let invoiceColumn = document.getElementById("invoice_chart");
    let invoiceChart = new ApexCharts(invoiceColumn, invoiceOptions);
    invoiceChart.render();
  }
}, [customernetweight]);


var sColStacked = {
  chart: {
    height: 500,
    type: "bar",
    stacked: true,
    toolbar: {
      show: true,
    },
  },

  colors: ['#709506', '#ededc8'],

  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "30%",
      dataLabels: {
        position: "top"
      }
    },
  },

  dataLabels: {
    enabled: true,
    formatter: function (val) {
      return Number(val).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    style: {
      fontSize: "14px",
      colors: ["#000"],
    },
    offsetY: -20,
    offsetX: 0,
  },

  // ✅ Hover Effect
  states: {
    normal: {
      filter: { type: 'none' }
    },
    hover: {
      filter: {
        type: 'darken', // ya "darken" bhi use kar sakte ho
        value: 0.2       // hover color intensity
      }
    },
    active: {
      filter: {
        type: 'darken',
        value: 0.35
      }
    }
  },

  // ✅ Tooltip Styling
  tooltip: {
    style: {
      fontSize: "14px",
      fontFamily: undefined,
      color: "#000",  // black text
    },
    theme: "light"   // background light rakho
  },

  series: [
    {
      name: "Paid",
      data: cusomerrevenues.sum_paid_all || [],
    },
    {
      name: "Open",
      data: cusomerrevenues.open_amount_all || [],
    },
  ],

  xaxis: {
    type: "category",
    categories: cusomerrevenues.customer_names || [],
    labels: {
      rotate: -45,
      rotateAlways: true,
      trim: true,
      style: { fontSize: "14px" }
    }
  },

  yaxis: {
    labels: {
      formatter: function (val) {
        return Number(val).toLocaleString(undefined, { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
        });
      },
      style: {
        fontSize: "12px" // ✅ Font size increase کیا گیا
      }
    }
  },

  legend: {
    position: "right",
    offsetY: 40,
  },

  fill: {
    opacity: 1,
  },
};

      
  var sColStacked_caliber = {
  chart: {
    height: 350,
    type: "bar",
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  colors: ['#709506', '#ededc8'], // green and cream

  plotOptions: {
    bar: {
      horizontal: false,
    },
  },
  series: [
    {
      name: "Percentage",
      data: dataacaliber.all_percentage || [],
    },
  ],
  xaxis: {
    type: "category",
    categories: dataacaliber.all_calibre || [],
    labels: {
      rotate: -45,
      style: {
        fontSize: "12px",
      },
    },
  },
 legend: {
    show: true,
    position: "bottom",
    horizontalAlign: "center",
    offsetY: 10,
  },
  fill: {
    opacity: 1,
  },
   yaxis: {
    labels: {
      formatter: function (val) {
        return val + " %";
      },
      style: {
        fontSize: "12px",
      },
    },
  },
  responsive: [
     {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
  ],
};

 const [profileImages, setProfileImages] = useState({});

  useEffect(() => {
    const fetchAllImages = async () => {
      const s3Client = new S3Client({
        region: AWS_DEFAULT_REGION,
        credentials: {
          accessKeyId: AWS_ACCESS_KEY_ID,
          secretAccessKey: AWS_SECRET_ACCESS_KEY,
        },
      });

      const urls = {};
      for (const item of cusomerbalance) {
        if (item.company_logo) {
          try {
            const command = new GetObjectCommand({
              Bucket: AWS_BUCKET,
              Key: item.company_logo,
            });
            const url = await getSignedUrl(s3Client, command, { expiresIn: 3600 });
            urls[item.company_logo] = url;
          } catch (error) {
            console.error("Error fetching signed URL for", item.company_logo, error);
            urls[item.company_logo] = null; // optional fallback
          }
        }
      }
    setProfileImages(urls);
    };

    fetchAllImages();
  }, [cusomerbalance]);

  const downloadpdf = () => {
  const input = document.getElementById('downloadpdf');

  html2canvas(input, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // YYYY-MM-DD
  const fileName = `Admin Dashboard ${formattedDate}.pdf`;
    pdf.save(fileName);
  });
};
 
 const viewReceiption = () => {
  window.location.href = "/raw-materials";

}
const viewFinalProducts = () => {
  localStorage.setItem('tableColumnFilters',JSON.stringify( [{"id":"Pallet Type","value":"Final product"}]));
  window.location.href = "/production-output/";

}
const viewDecayProducts = () => {
  localStorage.setItem('tableColumnFilters',JSON.stringify( [{"id":"Pallet Type","value":"Decay"}]));
  window.location.href = "/production-output/";

}

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
             
 <div className="content container-fluid top-dashboardfilter" >

<div className="row" >
                 
                  <div className="col-md-6">
                   
                      <label><b>Select The Date Range</b></label><br/>
                      <DateRangePicker
                        value={value}
                        className="dashboard-daterange"
                        // onChange={setValue}
                          onChange={handleDateChange2}
                        placeholder="Select Date Range"
                        style={{ width: 300 }}
                        ranges={predefinedRanges}
                        showOneCalendar={false}
                      />
                      
                    </div>
                    <div className="col-md-6">
                      <div className="" style={{float:'right'}}>
                          <button onClick={downloadpdf} className="btn btn-primary me-1" >
                          Export PDF <i className="fa fa-download" />
                        </button>
                      </div> 
                  </div>

              </div>
 </div>
            


             
          <div className="content container-fluid main-dashboard-contain" id="downloadpdf">
           


            <div className="row" >
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-database"></i> Overview</h5><hr/></div>
                      <div className="col-xl-6 col-sm-6 col-12">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site2">
                        <i className="fa fa-balance-scale	"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total Net Weight</div>
                        <div className="dash-counts">
                            <p>{dataBoxes.total_net_weight} (KG)</p>
                        </div>
                      </div>
                    </div>
                      </div>
                    <div className="col-xl-6 col-sm-6 col-12">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site">
                        <i className="fas fa-file-alt"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Number Of Loads</div>
                        <div className="dash-counts">
                          <p>{dataBoxes.number_of_loads}</p>
                        </div>
                      </div>
                    </div>
                      </div>
                    </div>
                     
                  </div>
                </div>
              </div>

            <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-bars	"></i> Invoice Statistics</h5><hr/></div>
                      <div className="col-xl-6 col-sm-6 col-12">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site3">
                        <i className="fas fa-euro"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total sales </div>
                        <div className="dash-counts">
                          <p>{dataBoxes.total_amount}</p>
                        </div>
                      </div>
                    </div>
                      </div>
                    <div className="col-xl-6 col-sm-6 col-12">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site2">
                        <i className="fas fa-euro"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Total Credit Note</div>
                        <div className="dash-counts">
                          <p>{dataBoxes.credit_note}</p>
                        </div>
                      </div>
                    </div>
                      </div>
                    </div>
                     
                  </div>
                </div>
              </div>
           
                     
            <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-align-justify"></i> Sale Analytics</h5><hr/></div>
                      <div className="col-xl-6 col-sm-6 col-12">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site">
                        <i className="far fa-file"></i>
                      </span>
                       <div className="dash-count">
                        <div className="dash-title">Total Received</div>
                        <div className="dash-counts">
                          <p>
                          <p>
                    {customertotalreceivedopen?.received !== undefined
                      ? new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(customertotalreceivedopen.received)
                      : "0.00"}
                  </p>
                        </p>
                        </div>
                      </div>
                    </div>
                      </div>
                    <div className="col-xl-6 col-sm-6 col-12">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site3">
                        <i className="fas fa-file-alt"></i>
                      </span>
                       <div className="dash-count">
                        <div className="dash-title">Total Pending</div>
                        <div className="dash-counts">
                         {/* <p>{customertotalreceivedopen.open.toFixed(2)}</p> */}
                         <p>
                              {customertotalreceivedopen?.open !== undefined
                                ? new Intl.NumberFormat("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(customertotalreceivedopen.open)
                                : "0.00"}
                            </p>

                        </div>
                      </div>
                    </div>
                      </div>
                    </div>
                     
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-database"></i> Total receptions</h5><hr/></div>
                      <div className="col-xl-12 col-sm-12 col-12">
                     <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site3">
                        <i className="fas fa-shopping-basket"></i>
                      </span>
                      <div className="dash-count">
                       
                        <div className="dash-counts">
                          <p>{dataBoxes.bl_net_weight}(KG)</p>
                        </div>
                      </div>
                    </div>
                        <hr/>
                        <p className=" mt-3 mb-0">
                           <button   onClick={() => viewReceiption()}   className="btn btn-link color-site me-1"  > View Receptions  </button>
                          {/* <a href="/raw-materials"> <i className="fas fa-file me-1"></i> View Receptions</a> */}
                        </p>
                      </div>
                      </div>
                    
                    </div>
                     
                  </div>
                </div>
              </div>
               
          


              
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-database"></i> Total Final Product</h5><hr/></div>
                      <div className="col-xl-12 col-sm-12 col-12">
                     <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site2">
                        <i className="fa fa-hashtag"></i>
                      </span>
                      <div className="dash-count">
                       
                        <div className="dash-counts">
                          <p>{dataBoxes.production_final_net_weight} (KG)</p>
                        </div>
                      </div>
                    </div>
                        <hr/>
                        <p className=" mt-3 mb-0">
                          <button   onClick={() => viewFinalProducts()}   className="btn btn-link color-site me-1"  > View Finished Products  </button>
                        </p>
                      </div>
                      </div>
                    
                    </div>
                     
                  </div>
                </div>
              </div>
               
              
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-database"></i> Total Decay</h5><hr/></div>
                      <div className="col-xl-12 col-sm-12 col-12">
                     <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-site">
                        <i className="far fa fa-database"></i>
                      </span>
                      <div className="dash-count">
                       
                        <div className="dash-counts">
                          <p>{dataBoxes.production_final_decay} (KG)</p>
                        </div>
                      </div>
                    </div>
                        <hr/>
                        <p className=" mt-3 mb-0">
                          {/* <a href="/production-output"> <i className="fas fa-file me-1"></i> View Finished Products</a> */}
                          <button   onClick={() => viewDecayProducts()}   className="btn btn-link color-site me-1"  > View Decay Products  </button>
                        </p>
                      </div>
                      </div>
                    
                    </div>
                     
                  </div>
                </div>
              </div>
               
          
           
           
              
            </div>

           

            <div className="row">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Customers Invoices</h5>
                    </div>
                    <div className="card-body">
                      <div style={{ overflowX: 'auto', width: '100%' }}>
                        <div 
                        style={{ 
                            minWidth: ((cusomerrevenues?.customer_names?.length || 0) * 120) + "px" 
                          }}>
                          <ReactApexChart
                            options={sColStacked}
                            series={sColStacked.series}
                            type="bar"
                            height={500}
                          />
                        </div>
                      </div>

                    
                    </div>
                  </div>
            </div>
           <div className="col-xl-6 d-flex" >
                <div className="card flex-fill">
                  <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="card-title">Top Sale Statistics</h5>
                     
                    </div>
                  </div>
                  <div className="card-body">
                    <div id="invoice_chart"></div>
                   
                  </div>
                </div>
              </div> 

              <div className="col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title"> Customer Balances</h5>
                      </div>
                      <div className="col-auto">
                        <Link
                          to="/customer-balances"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                 

                    <div className="table-responsive">
                      <table className="table table-stripped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Customer</th>
                            <th>Total Sale</th>
                            <th>Paid Amount</th>
                            <th>Total Credit Note Amount</th>
                            <th>Open Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cusomerbalance.map((item, index) => {
                           

                            return (
                              <tr key={index}>
                                 <td>
                                    <h2 className="table-avatar">
                                     <Link to={`/customer-balances-details/${item.id}`}>

                                        <img
                                          className="aavatar avatar-sm me-2 avatar-img rounded-circle"
                                          src={profileImages[item.company_logo] || "/default-avatar.png"} // fallback if URL not ready
                                          alt="User"
                                        />
                                        {item.company_name}
                                      </Link>
                                    </h2>
                                  </td>
                                <td>{item.total_sale.toFixed(2)}</td>
                                <td>{item.paid_amount.toFixed(2)}</td>
                                <td>{item.credit_note_amount.toFixed(2)}</td>
                                <td>{item.open_amount.toFixed(2)}</td>
                                
                               
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Calibers Analytics
 </h5>
                    </div>
                    <div className="card-body">
                      {/* <div id="s-col-stacked" /> */}
                      <div style={{ overflowX: 'auto', width: '100%' }}>
                          <div style={{ minWidth: '1000px' }}> {/* Adjust width as needed */}
                                  <ReactApexChart
                                    options={sColStacked_caliber}
                                    series={sColStacked_caliber.series}
                                    type="bar"
                                    height={350}
                                  />
                          </div>
                        </div>

                    </div>
                  </div>
                </div>
                  <div className="col-md-6">
                        <div className="card">
                          <div className="card-header">
                            <h5 className="card-title">Weekly Average Price Analytics</h5>
                          </div>
                            <div className="card-body">
                                  <div id="s-line" />
                                        {/* <div style={{ overflowX: 'auto', width: '100%' }}>
                                              <div style={{ minWidth: '1000px' }}> 
                                                    <ReactApexChart
                                                      options={sLineArea}
                                                      series={sLineArea.series}
                                                      type="line"
                                                      height={350}
                                                    />
                                              </div>
                                        </div> */}
                                          <ReactApexChart
                                                      options={sLineArea}
                                                      series={sLineArea.series}
                                                      type="line"
                                                      height={350}
                                                    />
            
                                </div>
                        </div>
                  </div>
                </div>
          <div className="row">
            
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Top 10  Suppliers By Open Amount </h5>
                      </div>
                      <div className="col-auto">
                        <Link
                          to="/supplier-balances"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                    
                    </div>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Customer</th>
                            <th>Total amount</th>
                            <th>Paid Amount</th>
                            <th>Open Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerpayment.map((item, index) => {
                           
                            return (
                              <tr key={index}>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link  to={`/supplier-balances-detail/${item.supplier_id}`} >
                                      {item.supplier_name}
                                    </Link>
                                  </h2>
                                </td>
                                <td>{item.sum_final_amount}</td>
                                <td>{item.sum_final_payment_1_2}</td>
                                <td>{item.situation}</td>
                               
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Top 10 Decay Customer by Open Amount</h5>
                      </div>
                      <div className="col-auto">
                        <Link
                          to="/decay-sales"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                    
                    </div>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Customer</th>
                            <th>Total amount</th>
                            <th>Paid Amount</th>
                            <th>Open Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {groupbycustomer.map((item, index) => {
                           
                            return (
                              <tr key={index}>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link  to={`/decay-sales-customer/${item.customer_id}`}>
                                      {item.customer_name}
                                    </Link>
                                  </h2>
                                </td>
                                <td>{item.customer_total_price}</td>
                                <td>{item.customer_paid_amount?.total_cost ?? 0}</td>
                                <td>{item.open_amount}</td>

                               
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        

           
          </div>
        </div>
      </div>
    </>
  );
};
export default MainDashboard;
